export const en = {
  "app.name": "Auth Platform",
  "app.console": "Console",
  "common.loading": "Loading…",
  "common.retry": "Retry",
  "common.reload": "Reload",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.create": "Create",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.confirm": "Confirm",
  "common.copy": "Copy",
  "common.showPassword": "Show password",
  "common.hidePassword": "Hide password",
  "common.copied": "Copied",
  "common.search": "Search",
  "common.yes": "Yes",
  "common.no": "No",
  "common.none": "None",
  "common.enabled": "Enabled",
  "common.disabled": "Disabled",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.moveUp": "Move up",
  "common.moveDown": "Move down",
  "common.never": "Never",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.rowsPerPage": "Rows per page",
  "common.errorTitle": "Something went wrong",
  "common.readOnly": "Read only",
  "common.noPermission": "You do not have permission to change this.",
  "common.saved": "Saved",
  "common.all": "All",
  "common.download": "Download",
  "common.optional": "optional",

  "nav.overview": "Overview",
  "nav.authentication": "Authentication",
  "nav.users": "Users",
  "nav.signInMethod": "Sign-in method",
  "nav.roles": "Roles",
  "nav.customFields": "Custom fields",
  "nav.applications": "Applications",
  "nav.oauthClients": "OAuth clients",
  "nav.monitor": "Monitor",
  "nav.auditLogs": "Audit logs",
  "nav.settings": "Settings",
  "nav.branding": "Branding",
  "nav.data": "Data & export",
  "nav.logRetention": "Log retention",
  "nav.openMenu": "Open navigation",
  "nav.main": "Main navigation",
  "nav.collapse": "Collapse sidebar",
  "nav.expand": "Expand sidebar",

  "header.docs": "Docs",
  "header.help": "Help",
  "help.title": "User manual",
  "help.contents": "Contents",
  "help.onThisPage": "On this page",
  "help.access": "Who can use it",
  "help.fields": "Field",
  "help.description": "What it is / what it does",
  "help.required": "required",
  "help.steps": "Step by step",
  "help.tips": "Tips",
  "help.warnings": "Be careful",
  "help.related": "Read next",
  "help.noImage": "Screenshot not generated yet",
  "help.openImage": "Open the full-size image",
  "help.notFound": "This manual page does not exist. Pick a topic from the contents.",
  "header.account": "Account",
  "header.signOut": "Sign out",
  "header.language": "Language",
  "header.userMenu": "Account menu",
  "header.sections": "Sections",
  "footer.version": "version {{version}}",

  "login.heroTitle": "Manage every account in one place",
  "login.heroBody":
    "Users, groups, roles and the applications they may sign in to — with every change recorded in the audit log.",
  "login.title": "Sign in to the console",
  "login.subtitle": "Manage users, roles, sign-in methods and OAuth clients.",
  "login.button": "Sign in with {{name}}",
  "login.hint":
    "You will continue on the sign-in page of the auth server (email, phone number or user code, then two-factor authentication) and come back here.",
  "login.expired": "Your session expired. Sign in again to continue where you left off.",
  "login.signedOut": "You have signed out.",
  "login.unavailable": "Cannot reach the auth server. Try again in a moment.",
  "auth.redirecting": "Redirecting to sign in…",
  "auth.callback": "Completing sign-in…",
  "auth.failed": "Sign-in failed",
  "auth.tryAgain": "Try again",
  "auth.noAccessTitle": "No access",
  "auth.noAccessBody":
    "Your account ({{email}}) does not have permission to use the admin console. Ask an administrator to grant you a role.",
  "auth.initialPassword":
    "root still uses its generated initial password (readable with `root:initial-password`). Changing it is recommended.",
  "auth.changePassword": "Change password",
  "auth.mfaRequired": "Your role requires two-factor authentication. Set it up now to keep access.",
  "auth.mfaSetup": "Set up 2FA",

  "error.forbidden": "You do not have permission to perform this action.",
  "error.rateLimited": "Too many requests. Try again in {{seconds}} seconds.",
  "error.network": "Network error — check your connection.",

  "overview.totalUsers": "Total users",
  "overview.active7d": "Active (7 days)",
  "overview.signInsToday": "Sign-ins today",
  "overview.failed24h": "Failed sign-ins (24 h)",
  "overview.mfaAdoption": "MFA adoption",
  "overview.chartTitle": "Sign-ins, last 14 days",
  "overview.chartLabel": "Line chart of daily sign-ins over the last 14 days",
  "overview.recent": "Recent events",
  "overview.viewAll": "View all audit logs",

  "users.searchPlaceholder": "Search by email, phone, name, user ID or employee code",
  "users.add": "Add user",
  "users.empty": "No users yet — add the first one",
  "users.emptyFiltered": "No users match your filters",
  "users.col.identifier": "Identifier",
  "users.col.providers": "Providers",
  "users.col.created": "Created",
  "users.col.lastSignIn": "Signed in",
  "users.col.status": "Status",
  "users.col.roles": "Roles",
  "users.filter.status": "Status",
  "users.filter.role": "Role",
  "users.filter.mfa": "MFA",
  "users.filter.mfaOn": "MFA on",
  "users.filter.mfaOff": "MFA off",
  "users.table": "Users",
  "status.active": "Active",
  "status.banned": "Banned",
  "status.pending": "Pending",
  "users.dialog.title": "Add user",
  "users.dialog.email": "Email",
  "users.dialog.name": "Display name",
  "users.dialog.userCode": "User code (optional)",
  "users.dialog.userCodeInvalid": "Use 3–32 letters, digits, . _ or - (not a phone number)",
  "users.dialog.userCodeTaken": "This user code is already taken",
  "users.dialog.username": "Username (optional)",
  "users.dialog.usernameInvalid": "Use 3–32 letters, digits, . _ or - for the username (not a phone number)",
  "users.dialog.usernameTaken": "This username is already taken",
  "users.dialog.roles": "Roles",
  "users.dialog.sendInvite": "Send an invitation email so the user can set a password",
  "users.dialog.submit": "Add user",
  "users.created": "User created",
  "users.provider.password": "Email/password",

  "user.back": "Back to users",
  "user.tab.profile": "Profile",
  "user.tab.security": "Security",
  "user.tab.roles": "Roles",
  "user.tab.sessions": "Sessions",
  "user.tab.activity": "Activity",
  "user.tab.identifiers": "Emails & phones",
  "ident.hint":
    "The user can sign in with any verified email or phone number. The primary email is the account email that applications receive (OIDC email).",
  "ident.type": "Type",
  "ident.type.email": "Email",
  "ident.type.phone": "Phone",
  "ident.type.user_code": "User code",
  "ident.type.username": "Username",
  "ident.valueNameHint":
    "3–32 characters: letters, digits, . _ - (may start with a digit; not a phone number). Unique across user codes and usernames; signs in with the same password.",
  "users.rootBadge": "root",
  "users.rootHint": "Built-in superuser — only root itself can change this account.",
  "ident.value": "Email or phone number",
  "ident.valuePhoneHint": "National numbers like 081 234 5678 are saved as +66812345678.",
  "ident.status": "Status",
  "ident.added": "Added",
  "ident.primary": "Primary",
  "ident.verified": "Verified",
  "ident.unverified": "Not verified",
  "ident.add": "Add",
  "ident.addTitle": "Add an email or phone number",
  "ident.markVerifiedOnAdd": "Already verified (checked outside the system)",
  "ident.markVerifiedHint": "Otherwise the user confirms it with a code from their account page.",
  "ident.makePrimary": "Make primary",
  "ident.verifyNow": "Mark as verified",
  "ident.remove": "Remove",
  "ident.actions": "Actions for {{value}}",
  "ident.addedToast": "Identifier added",
  "ident.removedToast": "Identifier removed",
  "ident.primaryToast": "Primary updated",
  "ident.verifiedToast": "Marked as verified",
  "ident.removeTitle": "Remove this identifier?",
  "ident.removeBody": "{{value}} will no longer sign in to this account.",
  "ident.primaryTitle": "Make this the primary email?",
  "ident.primaryBody":
    "Applications will receive {{value}} as the user's email. The current primary email stays as an additional email.",
  "signin.phone": "Phone numbers",
  "signin.phoneEnabled": "Allow signing in with a verified phone number and password",
  "signin.phoneOtp": "Allow signing in with a one-time code by SMS",
  "signin.smsMissing":
    "SMS is not configured on the server (SMS_PROVIDER) — phone numbers cannot be verified by the user and SMS codes are unavailable.",
  "user.tabs": "User sections",
  "user.id": "User ID",
  "user.displayName": "Display name",
  "user.email": "Email",
  "user.emailVerified": "Email verified",
  "user.employeeCode": "Employee code",
  "user.firstName": "First name",
  "user.lastName": "Last name",
  "user.department": "Department",
  "user.position": "Position",
  "user.customFields": "Custom fields",
  "user.saveProfile": "Save profile",
  "user.mfa": "Two-factor authentication",
  "user.mfaOn": "Enabled",
  "user.mfaOff": "Not enrolled",
  "user.resetMfa": "Reset MFA",
  "user.resetMfaConfirm":
    "Remove this user's authenticator app and backup codes? They will need to enrol again.",
  "user.mfaReset": "MFA was reset",
  "user.passwordReset": "Send password reset",
  "user.passwordResetSent": "Password reset email sent",
  "user.password": "Password",
  "user.setPassword.action": "Set password",
  "user.setPassword.title": "Set a new password",
  "user.setPassword.generate": "Generate a random password (shown once)",
  "user.setPassword.type": "Type a password",
  "user.setPassword.new": "New password",
  "user.setPassword.confirm": "Confirm password",
  "user.setPassword.mismatch": "Passwords do not match",
  "user.setPassword.hint":
    "The user is signed out everywhere and must choose their own password at the next sign-in.",
  "user.setPassword.submit": "Set password",
  "user.setPassword.done": "Password set. The user must change it at the next sign-in.",
  "user.setPassword.once": "Copy it now and give it to the user privately — it is not shown again.",
  "user.linkedProviders": "Linked sign-in providers",
  "user.saveRoles": "Save roles",
  "user.rolesSaved": "Roles updated",
  "user.sessions.empty": "No active sessions",
  "user.sessions.revoke": "Revoke",
  "user.sessions.revokeAll": "Revoke all sessions",
  "user.sessions.revoked": "Session revoked",
  "user.sessions.created": "Started",
  "user.sessions.expires": "Expires",
  "user.sessions.device": "Device",
  "user.danger": "Danger zone",
  "user.ban": "Ban user",
  "user.banTitle": "Ban {{email}}",
  "user.banReason": "Reason",
  "user.banHint": "The user is signed out everywhere and cannot sign in until unbanned.",
  "user.banned": "User banned",
  "user.unban": "Unban user",
  "user.unbanned": "User unbanned",
  "user.bannedBecause": "Banned: {{reason}}",
  "user.delete": "Delete user",
  "user.deleteTitle": "Delete {{email}}",
  "user.deleteConfirm":
    "This permanently deletes the account and its profile. Type the email address to confirm.",
  "user.deleted": "User deleted",
  "user.export": "Export data (PDPA)",
  "user.created": "Created {{date}}",

  "signin.provider": "Provider",
  "signin.status": "Status",
  "signin.emailPassword": "Email/Password",
  "signin.google": "Google",
  "signin.microsoft": "Microsoft",
  "signin.passkey": "Passkey",
  "signin.unsupported": "Not supported yet",
  "signin.notConfigured":
    "Server secrets for {{provider}} are not configured — set them in the server environment before enabling.",
  "signin.editTitle": "Edit {{provider}}",
  "signin.enable": "Enable",
  "signin.allowSignUp": "Allow users to sign up",
  "signin.requireVerification": "Require email verification",
  "signin.domains": "Allowed email domains",
  "signin.domainsHint": "Leave empty to allow any domain. Example: company.co.th",
  "signin.addDomain": "Add domain",
  "signin.minLength": "Minimum password length",
  "signin.mfa": "Multi-factor authentication",
  "signin.mfaPolicy": "Policy",
  "signin.policy.optional": "Optional",
  "signin.policy.required_for_admins": "Required for administrators",
  "signin.policy.required_for_all": "Required for everyone",
  "signin.methods": "Methods",
  "signin.method.totp": "Authenticator app (TOTP)",
  "signin.method.email_otp": "Code by email",
  "signin.session": "Session",
  "signin.maxAge": "Session lifetime (days)",
  "signin.idle": "Idle timeout (minutes, optional)",
  "signin.save": "Save changes",
  "signin.conflict": "Settings were changed by someone else — reload to see the latest version.",

  "roles.add": "Create role",
  "roles.name": "Name",
  "roles.description": "Description",
  "roles.permissions": "Permissions",
  "roles.builtIn": "Built-in",
  "roles.editTitle": "Edit role {{name}}",
  "roles.createTitle": "Create role",
  "roles.nameHint": "Lowercase letters, digits, - or _. Cannot be changed later.",
  "roles.deleteConfirm": "Delete role {{name}}?",
  "roles.empty": "No roles",
  "perm.users": "Users",
  "perm.roles": "Roles",
  "perm.logs": "Audit logs",
  "perm.settings": "Settings",
  "perm.clients": "OAuth clients",
  "perm.data": "Data",

  "fields.add": "Add field",
  "fields.key": "Key",
  "fields.labelTh": "Label (Thai)",
  "fields.labelEn": "Label (English)",
  "fields.type": "Type",
  "fields.options": "Options (one per line)",
  "fields.required": "Required",
  "fields.showOnSignUp": "Show on sign-up",
  "fields.includeInClaims": "Include in token claims (employee scope)",
  "fields.empty": "No custom fields yet — add one to extend employee profiles",
  "fields.type.string": "Text",
  "fields.type.number": "Number",
  "fields.type.boolean": "Yes/No",
  "fields.type.date": "Date",
  "fields.type.select": "Select",
  "fields.editTitle": "Edit field",
  "fields.save": "Save fields",

  "clients.register": "Register client",
  "clients.empty": "No OAuth clients yet — register your first application",
  "clients.col.name": "Name",
  "clients.col.clientId": "Client ID",
  "clients.col.type": "Type",
  "clients.col.status": "Status",
  "clients.firstParty": "First-party",
  "clients.type.confidential": "Confidential",
  "clients.type.public": "Public (SPA / mobile)",
  "clients.name": "Application name",
  "clients.redirectUris": "Redirect URIs",
  "clients.postLogoutUris": "Post-logout redirect URIs",
  "clients.addUri": "Add URI",
  "clients.scopes": "Allowed scopes",
  "clients.firstPartyHint": "First-party apps skip the consent screen",
  "clients.backchannel": "Back-channel logout URI",
  "clients.ownerTeam": "Owner team",
  "clients.description": "Description",
  "clients.secretTitle": "Client secret",
  "clients.secretWarning": "Copy this secret now. It will not be shown again.",
  "clients.secretDone": "I have stored the secret",
  "clients.rotate": "Rotate secret",
  "clients.rotateConfirm": "Rotating immediately invalidates the current secret. Continue?",
  "clients.disable": "Disable",
  "clients.enable": "Enable",
  "clients.tab.settings": "Settings",
  "clients.tab.integration": "Integration",
  "clients.issuer": "Issuer",
  "clients.discovery": "Discovery URL",
  "clients.snippets": "Code snippets",
  "clients.back": "Back to clients",
  "clients.saved": "Client updated",
  "clients.registered": "Client registered",

  "logs.type": "Event type",
  "logs.actor": "Actor ID",
  "logs.subject": "Subject user ID",
  "logs.from": "From",
  "logs.to": "To",
  "logs.apply": "Apply filters",
  "logs.clear": "Clear",
  "logs.loadMore": "Load more",
  "logs.exportCsv": "Export CSV",
  "logs.col.time": "Time",
  "logs.col.event": "Event",
  "logs.col.actor": "Actor",
  "logs.col.subject": "Subject",
  "logs.col.ip": "IP",
  "logs.empty": "No audit events match",
  "logs.details": "Show details",
  "logs.table": "Audit log",

  "branding.productName": "Product name",
  "branding.logoUrl": "Logo URL",
  "branding.primaryColor": "Primary color",
  "branding.supportEmail": "Support email",
  "branding.preview": "Preview",
  "branding.previewButton": "Sign in",
  "clients.tab.branding": "Branding",
  "clientBranding.hint":
    "How the sign-in pages look when people arrive from this application. Empty fields use Settings → Branding.",
  "clientBranding.ownColor": "Use a color for this application",
  "clientBranding.logoHint": "HTTPS image, shown instead of the product logo",
  "clientBranding.open": "Open the sign-in page",
  "heroText.section": "Sign-in page text",
  "heroText.globalHint":
    "Headline and text on the left of the sign-in pages. Leave a field empty to use the built-in text (shown greyed out).",
  "heroText.appHint": "Leave a field empty to use the text from Settings → Branding (shown greyed out).",
  "heroText.title.th": "Headline (Thai)",
  "heroText.title.en": "Headline (English)",
  "heroText.body.th": "Text (Thai)",
  "heroText.body.en": "Text (English)",
  "heroText.titleHint": "Press Enter for a line break",
  "branding.previewLink": "Forgot password?",

  "data.start": "Start export",
  "data.includeLogs": "Include audit logs",
  "data.includeCredentials": "Include credentials (password hashes, TOTP secrets — encrypted)",
  "data.jobs": "Export jobs",
  "data.empty": "No exports yet",
  "data.finished": "Finished",
  "data.status.pending": "Pending",
  "data.status.running": "Running",
  "data.status.done": "Done",
  "data.status.failed": "Failed",
  "data.started": "Export started",
  "data.import": "Import",
  "data.importHint":
    "Use the CLI for imports: pnpm --filter @platform/auth-server cli import --in file.jsonl --dry-run",

  "retention.days": "Keep audit logs for (days)",
  "retention.hint": "Older entries are purged automatically every few hours.",
  "nav.groups": "Groups",
  "nav.userTypes": "User types",
  "perm.groups": "Groups",
  "user.tab.access": "Access",
  "users.dialog.userTypeHint": "Console roles can only be given to employees.",
  "clients.col.access": "Access",
  "clients.tab.access": "Access",

  "access.userType": "User type",
  "access.userTypes": "User types",
  "access.groups": "Groups",
  "access.everyone": "Everyone",
  "access.everyoneHint": "Any active account can sign in, including customers who sign up themselves.",
  "access.restricted": "Only selected user types and groups",
  "access.restrictedHint": "Accounts of a listed user type, or members of a listed group, can sign in.",
  "access.nobody": "Nobody",
  "access.whoCanSignIn": "Who can sign in",
  "access.needOne": "Select at least one user type or group.",
  "access.signUpAs": "Allow sign-up as",
  "access.signUpAsHint":
    "Visitors of this application can create an account of this type. Only types with self sign-up enabled are listed.",
  "access.noSignUp": "No sign-up",
  "access.signUpNotAllowed": "This user type does not allow self sign-up.",
  "access.signUpNotListed": "The sign-up type must also be one of the selected user types.",
  "access.revokeHint":
    "Tightening access immediately revokes the tokens of users who are no longer allowed; they are signed out of this application.",
  "access.consoleManaged":
    "Access to the admin console is managed by the platform: only accounts with a console role can sign in.",
  "access.newDefault": "New applications allow employees only. Change it now or later on the Access tab.",
  "access.typeHint":
    "The user type decides which applications the account may use. Changing it revokes the user's application tokens.",
  "access.rootSystem":
    "The root account is a system account: it has no user type, cannot join groups, and signs in to this console only — never to other applications.",
  "access.systemAccount": "System account",
  "access.changeType": "Change type",
  "access.changeTypeTitle": "Change user type",
  "access.changeTypeBody":
    "Change {{email}} from {{from}} to {{to}}? The user is signed out of applications they can no longer use.",
  "access.typeChanged": "User type changed",
  "access.groupsHint": "Groups give access to applications that allow them and appear in the groups claim.",
  "access.saveGroups": "Save groups",
  "access.groupsSaved": "Groups updated",
  "access.applications": "Applications",
  "access.applicationsHint": "Whether this user may sign in to each application, based on type and groups.",
  "access.canSignIn": "Can sign in",
  "access.cannotSignIn": "No access",
  "access.rolesEmployeesOnly": "Console roles are available to employees only.",
  "access.slugInvalid": "2–41 characters: a lowercase letter first, then a–z, 0–9, - or _.",

  "groups.intro":
    "Groups are teams of users. Applications can allow a group, and the group ids appear in the groups claim of tokens.",
  "groups.add": "Create group",
  "groups.createTitle": "Create group",
  "groups.created": "Group created",
  "groups.id": "ID",
  "groups.idHint":
    "Lowercase letters, digits, - or _ (e.g. chat-agents). Appears in tokens; cannot be changed later.",
  "groups.name": "Name",
  "groups.description": "Description",
  "groups.members": "Members",
  "groups.memberCount": "{{count}} members",
  "groups.membersHint": "Removing a member revokes their tokens at applications they can no longer use.",
  "groups.empty": "No groups yet",
  "groups.noMembers": "No members yet",
  "groups.back": "Back to groups",
  "groups.addMembers": "Add members",
  "groups.addMembersTitle": "Add members to {{name}}",
  "groups.addSelected": "Add {{count}} selected",
  "groups.alreadyMember": "Member",
  "groups.searchResults": "Users",
  "groups.membersAdded": "{{count}} members added",
  "groups.memberRemoved": "Member removed",
  "groups.removeMemberTitle": "Remove member",
  "groups.removeMemberBody": "Remove {{name}} from {{group}}?",
  "groups.removeMemberLabel": "Remove {{name}}",
  "groups.applications": "Applications using this group",
  "groups.noApplications": "No application allows this group yet.",
  "groups.delete": "Delete group",
  "groups.deleteTitle": "Delete group {{name}}",
  "groups.deleteBody":
    "Members lose the access this group gave them. A group that an application or a user type still uses cannot be deleted.",
  "groups.deleted": "Group deleted",

  "userTypes.intro":
    "Every account has exactly one user type (employee, customer, partner or a custom type). Applications allow user types; the type appears in tokens as user_type.",
  "userTypes.domainsExplain":
    "Email domains: addresses with these domains that sign up get this type (for example your company domain → employee).",
  "userTypes.add": "Create user type",
  "userTypes.createTitle": "Create user type",
  "userTypes.editTitle": "Edit user type {{name}}",
  "userTypes.id": "ID",
  "userTypes.idHint": "Lowercase letters, digits, - or _. Appears in tokens; cannot be changed later.",
  "userTypes.name": "Name",
  "userTypes.description": "Description",
  "userTypes.accounts": "Accounts",
  "userTypes.selfSignUp": "Self sign-up",
  "userTypes.selfSignUpHint":
    "Visitors may create an account of this type themselves, through an application that offers sign-up as this type.",
  "userTypes.emailDomains": "Email domains",
  "userTypes.emailDomainsHint":
    "One per line. Addresses with these domains that sign up get this type; *.example.com matches sub-domains.",
  "userTypes.mfa": "Two-factor rule",
  "userTypes.mfaHint": "Inherit follows the global policy in Sign-in method.",
  "userTypes.mfa.inherit": "Inherit global policy",
  "userTypes.mfa.optional": "Optional",
  "userTypes.mfa.required": "Required",
  "userTypes.defaultGroups": "Default groups",
  "userTypes.defaultGroupsHint": "New accounts of this type join these groups automatically.",
  "userTypes.empty": "No user types",
  "userTypes.deleteConfirm":
    "Delete user type {{name}}? This is refused while accounts or applications still use it.",
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
